import React, {useEffect, useMemo} from 'react'
import {Box, Heading, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useParams, useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import Link from '@salesforce/retail-react-app/app/components/link'
import {formattedDate} from '../../utills/helperServices'
import LoadingSpinner from '../../components/loading-spinner'
import RecommendedProducts from '../../components/recommended-products'
import useFetchLibraryFolders from '../../hooks/useFetchLibrary'
import {getUrlSearchParam} from '../../utills/url'
import TagsLink from './TagsLink'
import {ShareLinks} from './ShareLink'
import {BlogDetailsStyle} from './styles'
import {blogRoute} from '../../utills/url'
import {useToast} from '../../hooks/use-toast'
import BlogBreadcrumbs from './BlogBreadcrumbs'
import {pxToRem} from '../../utills/pxToRem'
import PageNotFound from '../../pages/page-not-found'

const BlogDetail = () => {
    const {contentID} = useParams()
    const {formatMessage} = useIntl()
    const location = useLocation()
    const showToast = useToast()

    const {data, loading, error} = useFetchLibraryFolders(`content/${contentID}`)

    const previousSearchParams = useMemo(() => {
        const {snitizeUrlSearchParam} = getUrlSearchParam(location.search)
        return snitizeUrlSearchParam
    }, [location.search])
    useEffect(() => {
        if (data?.fault && !loading) {
            const getError = async () => {
                if (data?.fault?.message) {
                    showToast({
                        title: data?.fault?.message,
                        status: 'error',
                        position: 'top-right'
                    })
                } else {
                    showToast({
                        title: 'Failed to fetch blog details, try again!',
                        status: 'error',
                        position: 'top-right'
                    })
                }
            }
            getError()
        }
    }, [error, data?.fault])

    if (loading && !error) {
        return <LoadingSpinner />
    }

    if (error || !data?.c_body) {
        // Display PageNotFound if there's an error or no content body
        return <PageNotFound />
    }

    const decodeEntities = (str = '') => {
        const textarea = document.createElement('textarea')
        textarea.innerHTML = str
        return textarea.value
    }

    return (
        <Box sx={BlogDetailsStyle}>
            <Seo
                title={decodeEntities(data?.page_title)}
                description={decodeEntities(data.page_description)}
                keywords={decodeEntities(data.page_keywords)}
            />
            <Box className="blog-container">
                <BlogBreadcrumbs breadcrumbData={data?.c_breadcrumb} />
                {data?.c_heroImage && (
                    <Box className="blog-name">
                        <Link to={blogRoute('cavenders-ranch')}>
                            <Image
                                src={data.c_heroImage}
                                alt={formatMessage({
                                    id: 'blog.banner.image_alt_message',
                                    defaultMessage: 'Cavenders Ranch Blog'
                                })}
                            />
                        </Link>
                    </Box>
                )}
                <Box className="blog-content-asset">
                    <Box as="section">
                        <Heading as="h3">
                            <Box as="span" dangerouslySetInnerHTML={{__html: data?.name}}></Box>
                        </Heading>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Box as="p" minWidth={pxToRem(120)} textAlign={'left'}>
                                {formattedDate(data.c_BlogLinkArticleDate)}
                            </Box>
                            <TagsLink data={data} />
                        </Box>
                    </Box>
                    <Box
                        sx={{iframe: {width: '100%'}, marginBottom: pxToRem(8)}}
                        dangerouslySetInnerHTML={{__html: data?.c_body}}
                    ></Box>
                    <TagsLink tags data={data} />
                </Box>
                <Box className="blog-social-links">
                    <ShareLinks
                        title={data?.page_title}
                        description={data?.page_description}
                        image={data?.c_BlogLinkArticleFeaturedMedia}
                    />
                </Box>
                {/* <Box className="blog-shop-carousel">
                    <RecommendedProducts
                        title={formatMessage({
                            id: 'blog_detail.carousel.recommendation.shop_this_story',
                            defaultMessage: 'Shop This Story'
                        })}
                        recommender={'best-sellers-null-results'}
                        previousSearchParams={previousSearchParams}
                    />
                </Box> */}
            </Box>
        </Box>
    )
}

export default BlogDetail
